module.exports = __webpack_public_path__ + "static/media/salsas_checked.5622bbb4.svg";